import { Helmet } from "react-helmet-async";

function Contact() {
  return (
    <div className="max-w-3xl mx-auto p-6 text-gray-800">
      {/* 🔹 SEO Meta Tags */}
      <Helmet>
        <title>Contact Us - Build Pro Resume</title>
        <meta
          name="description"
          content="Get in touch with Build Pro Resume. Have questions or feedback? Reach out via email at support@buildproresume.com."
        />
        <meta name="robots" content="index, follow" />
      </Helmet>

      {/* 🔹 Contact Section */}
      <h1 className="text-3xl font-bold mb-4">Contact Us</h1>
      <p className="mb-4">
        Have questions, suggestions, or feedback? We'd love to hear from you!
        Reach out to us at:
        <span className="text-blue-600 font-semibold">
          {" "}
          support@buildproresume.com
        </span>
        .
      </p>

      {/* 🔹 Contact Details */}
      <div className="mt-6 space-y-6">
        <div>
          <h2 className="text-lg font-semibold">📧 Email:</h2>
          <p className="text-blue-600">support@buildproresume.com</p>
        </div>
        <div>
          <h2 className="text-lg font-semibold">📍 Address:</h2>
          <p>Currently working remotely ☕🚀</p>
        </div>
        <div>
          <h2 className="text-lg font-semibold">📞 Phone:</h2>
          <p>We're digital-first, so email is the best way to reach us! 📩</p>
        </div>
        <div>
          <h2 className="text-lg font-semibold">⏰ Working Hours:</h2>
          <p>We’re here whenever you need us—just drop us an email! 💼💡</p>
        </div>
      </div>
    </div>
  );
}

export default Contact;
